import { PhoneNumberUtil } from "google-libphonenumber";
import * as yup from "yup";
const phoneUtil = PhoneNumberUtil.getInstance();

export const validateOrganizationSetup = yup.object({
  name: yup
    .string()
    .required("Company Name is required")
    .nonNullable("Company Name is required"),
  vat_no: yup
    .string()
    .required("Vat No. is required")
    .nonNullable("Vat No. is required"),
  website: yup.string().optional().nullable(),
  address: yup
    .string()
    .required("Address is required")
    .nonNullable("Address is required"),
  phone: yup
    .string()
    .test("is-valid-phone", "Invalid phone number", (value) => {
      if (!value) return false;
      try {
        return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(value));
      } catch (error) {
        return false;
      }
    })
    .required("Phone number is required"),
  email: yup.string().email("Email is not valid").optional().nullable(),
  fiscal_year_start: yup.date().typeError("Invalid Date"),
  fiscal_year_end: yup.date().typeError("Invalid Date"),
});
